<script>
import axios from "axios";
import Swal from "sweetalert2";

const MAX_FILE_SIZE = 2 * 1024 * 1024; // 2 MB

export default {
  props: {
    show: Boolean,
    data: Object,
    mode: {
      type: String,
      default: "add",
    },
  },

  data() {
    return {
      BACKEND_URL_VERSION: process.env.VUE_APP_BACKEND_URL_VERSION,
      form: {
        idverif_file_referensi: null,
        nama_file: "",
        path_file: null,
      },
    };
  },

  watch: {
    modalShow(val) {
      if (val) {
        // 👉 modal OPENED
        if (this.mode === "edit" && this.data) {
          this.form = { ...this.data };
        } else {
          this.resetForm();
        }
      } else {
        // 👉 modal CLOSED
        this.resetForm();
      }
    },
  },

  computed: {
    modalShow: {
      get() {
        return this.show;
      },
      set(val) {
        if (!val) this.$emit("close");
      },
    },
  },

  methods: {
    resetForm() {
      this.form = {
        idverif_file_referensi: null,
        nama_file: "",
        path_file: null,
      };

      if(this.$refs.fileInput){
        this.$refs.fileInput.value = null;
      }
    },

    store() {
      if (!this.form.nama_file) {
        Swal.fire({
          icon: "warning",
          title: "Peringatan",
          text: "Nama referensi tidak boleh kosong.",
          showConfirmButton: true,
        });

        return;
      }

      const url = this.BACKEND_URL_VERSION + "verifikasi/referensi"

      const method = this.mode === "edit" ? "put" : "post";

      const formData = new FormData();
      formData.append("nama_file", this.form.nama_file);
      formData.append("path_file", this.form.path_file);

      axios({
        method,
        url,
        data: formData,
        headers: { Authorization: `Bearer ${localStorage.access_token}` },
      })
        .then((res) => {
          console.log(res);
          Swal.fire({
            icon: "success",
            title: "Berhasil",
            text:
              this.mode === "edit"
                ? "Data berhasil diperbarui"
                : "Data berhasil disimpan",
            timer: 1500,
            timerProgressBar: true,
            showConfirmButton: false,
          });

          this.$emit("close");
          // reload table
          this.$emit("finish");
        })
        .catch((err) => {
          // Beberapa server menolak file yang terlalu besar di level
          // web server/PHP (upload_max_filesize/post_max_size) sehingga
          // request gagal tanpa response body sama sekali.
          const isFileTooLarge =
            !err.response &&
            this.form.path_file instanceof File &&
            this.form.path_file.size > MAX_FILE_SIZE;

          Swal.fire({
            icon: "error",
            title: "Gagal",
            text: isFileTooLarge
              ? "Ukuran file terlalu besar. Maksimal ukuran file 2 MB."
              : err.response?.data?.data?.message || "Terjadi kesalahan.",
          });
        });
    }, // end of store

    handleFileChange(e) {
      const file = e.target.files[0];

      if (!file) return;

      if (file.type !== "application/pdf") {
        Swal.fire({
          icon: "warning",
          title: "File tidak valid",
          text: "Hanya file PDF yang diperbolehkan.",
        });

        // reset
        this.$refs.fileInput.value = null;
        this.form.path_file = null;
        return;
      }

      if (file.size > MAX_FILE_SIZE) {
        Swal.fire({
          icon: "warning",
          title: "File terlalu besar",
          text: "Ukuran file maksimal 2 MB.",
        });

        // reset
        this.$refs.fileInput.value = null;
        this.form.path_file = null;
        return;
      }

      this.form.path_file = file;
    },

  },
};
</script>

<template>
  <b-modal
    v-model="modalShow"
    title="Tambah Referensi"
    size="md"
    hide-footer
  >
    <b-form @submit.prevent="store">
      <b-form-group label="Nama Referensi" class="fw-medium">
        <b-form-input v-model="form.nama_file"></b-form-input>
      </b-form-group>

      <div class="form-group">
        <label for="file" class="form-label">Select File</label>
        <input
          type="file"
          ref="fileInput"
          class="form-control"
          @change="handleFileChange"
          accept="application/pdf"
          required
        />
        <small class="text-muted">Format file: PDF. Maksimal ukuran file 2 MB.</small>
        <div class="invalid-feedback">Please select a valid file.</div>
      </div>

      <div class="text-end mt-3">
        <b-button variant="secondary" class="me-2" @click="$emit('close')">
          Batal
        </b-button>
        <b-button type="submit" variant="primary"> Simpan </b-button>
      </div>
    </b-form>
  </b-modal>
</template>